import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { API } from "@/App";
import { AuthShell, AuthAlert, PasswordField, validateNewPassword } from "@/components/AuthShell";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(token ? "" : "This reset link is missing or invalid.");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const v = validateNewPassword(password, confirm);
    if (v) return setError(v);
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/org/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, new_password: password }),
      });
      const data = await res.json();
      if (res.ok) setDone(true);
      else setError(data.detail || "Could not reset password");
    } catch {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell subtitle="Reset your password">
      {error && <AuthAlert testId="reset-error">{error}</AuthAlert>}
      {done ? (
        <>
          <AuthAlert type="success" testId="reset-success">Your password has been reset. You can now sign in.</AuthAlert>
          <Link to="/login?org=1" data-testid="reset-go-login">
            <Button className="w-full h-12 bg-[#006994] hover:bg-[#005577] text-white rounded-xl">Go to Sign In</Button>
          </Link>
        </>
      ) : token ? (
        <form onSubmit={submit} className="space-y-4">
          <PasswordField label="New password" value={password} onChange={setPassword} placeholder="At least 8 characters" testId="reset-new-password" autoComplete="new-password" />
          <PasswordField label="Confirm new password" value={confirm} onChange={setConfirm} placeholder="Re-enter password" testId="reset-confirm-password" autoComplete="new-password" />
          <Button type="submit" disabled={loading} data-testid="reset-submit-btn" className="w-full h-12 bg-[#006994] hover:bg-[#005577] text-white rounded-xl">
            {loading ? "Saving..." : "Set New Password"}
          </Button>
        </form>
      ) : null}
      {!done && (
        <p className="text-center mt-4">
          <Link to="/login?org=1" className="text-sm text-[#006994] hover:underline" data-testid="reset-back-login">Back to sign in</Link>
        </p>
      )}
    </AuthShell>
  );
}
